<template>
    <div>
        <div class="overflow-hidden shadow rounded-lg border-t border-gray-200"
                :class="[{'mb-2' : isExpanded}, !isExpanded ? collapsedBg : 'bg-white']">
            <!--                class="">-->
            <div    class=""
                    @click="isExpanded = !isExpanded"
            >
                <!--            <div class="border-b border-gray-200 px-4 py-5 sm:px-6">-->
                <!-- 2 Column with Avatar https://tailwindui.com/components/application-ui/lists/stacked-lists#component-371ccbef96ba57325d261f1b74afdd41 -->
                <div    class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 cursor-pointer"
                        :class="isExpanded ? 'hover:bg-gray-50' : 'hover:' + collapsedBg">
                    <div class="flex items-center px-4 py-4 sm:px-6">
                        <div class="min-w-0 flex-1 flex items-center">
                            <div class="min-w-0 flex-1 px-4 grid md:grid-cols-2 sm:grid-cols-1 gap-4">
                                <div class="sm:col-span-1">
                                    <slot    name="well-header-left"></slot>
                                </div>
                                <div class="block sm:col-span-1">
                                    <slot    name="well-header-center"></slot>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-nowrap items-center">
                            <slot name="well-header-right">
                                <slot name="well-header-right-extra"></slot>
                                <span :class="isExpanded ? 'icon-chevron-up' : 'icon-chevron-right'"
                                      class="lnr"
                                ></span>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="isExpanded"
                 class="px-4 py-5 sm:p-6 border-t border-gray-100">
                <slot name="well-content">
                </slot>
            </div>
            <div v-show="isFooter" class="border-t border-gray-200 px-4 py-4 sm:px-6">
                <slot name="well-footer">

                </slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InstallWizardWell",
        props: {
            expanded: Boolean,
            collapsedBg: String,
        },
        data(){
            return {
                isExpanded: this.expanded,
                isFooter: false
            }
        },
        watch: {
            expanded(val) {
                this.isExpanded = val
            },
            isExpanded(val, old) {
                if (old !== val) {
                    this.$emit('update:expanded', this.isExpanded)
                }
            },
        }
    }
</script>

<style scoped>

</style>